/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { OrganizationContextCapabilitiesResponse } from "../types/organizationContextCapabilitiesResponse";

import type { OrganizationContextResponse } from "../types/organizationContextResponse";

import type { SetOrganizationRequest } from "../types/setOrganizationRequest";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getApiOrganizationContext = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationContextResponse>> => {
  return axios.default.get(`/api/organization-context`, options);
};

export const getGetApiOrganizationContextQueryKey = () => {
  return [`/api/organization-context`] as const;
};

export const getGetApiOrganizationContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiOrganizationContext>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrganizationContext>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiOrganizationContextQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiOrganizationContext>>
  > = ({ signal }) => getApiOrganizationContext({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrganizationContext>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiOrganizationContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiOrganizationContext>>
>;
export type GetApiOrganizationContextQueryError = AxiosError<unknown>;

export function useGetApiOrganizationContext<
  TData = Awaited<ReturnType<typeof getApiOrganizationContext>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiOrganizationContext>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiOrganizationContextQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const putApiOrganizationContext = (
  setOrganizationRequest: SetOrganizationRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.put(
    `/api/organization-context`,
    setOrganizationRequest,
    options,
  );
};

export const getPutApiOrganizationContextMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOrganizationContext>>,
    TError,
    { data: SetOrganizationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiOrganizationContext>>,
  TError,
  { data: SetOrganizationRequest },
  TContext
> => {
  const mutationKey = ["putApiOrganizationContext"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiOrganizationContext>>,
    { data: SetOrganizationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return putApiOrganizationContext(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiOrganizationContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiOrganizationContext>>
>;
export type PutApiOrganizationContextMutationBody = SetOrganizationRequest;
export type PutApiOrganizationContextMutationError = AxiosError<void>;

export const usePutApiOrganizationContext = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiOrganizationContext>>,
    TError,
    { data: SetOrganizationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof putApiOrganizationContext>>,
  TError,
  { data: SetOrganizationRequest },
  TContext
> => {
  const mutationOptions = getPutApiOrganizationContextMutationOptions(options);

  return useMutation(mutationOptions);
};
export const deleteApiOrganizationContext = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.delete(`/api/organization-context`, options);
};

export const getDeleteApiOrganizationContextMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiOrganizationContext>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiOrganizationContext>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteApiOrganizationContext"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiOrganizationContext>>,
    void
  > = () => {
    return deleteApiOrganizationContext(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiOrganizationContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiOrganizationContext>>
>;

export type DeleteApiOrganizationContextMutationError = AxiosError<unknown>;

export const useDeleteApiOrganizationContext = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiOrganizationContext>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiOrganizationContext>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getDeleteApiOrganizationContextMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getOrganizationContextCapabilities = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganizationContextCapabilitiesResponse>> => {
  return axios.default.get(`/api/organization-context/capabilities`, options);
};

export const getGetOrganizationContextCapabilitiesQueryKey = () => {
  return [`/api/organization-context/capabilities`] as const;
};

export const getGetOrganizationContextCapabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationContextCapabilities>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationContextCapabilities>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationContextCapabilitiesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizationContextCapabilities>>
  > = ({ signal }) =>
    getOrganizationContextCapabilities({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationContextCapabilities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOrganizationContextCapabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationContextCapabilities>>
>;
export type GetOrganizationContextCapabilitiesQueryError = AxiosError<unknown>;

export function useGetOrganizationContextCapabilities<
  TData = Awaited<ReturnType<typeof getOrganizationContextCapabilities>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationContextCapabilities>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetOrganizationContextCapabilitiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
